export default (axios, baseURL) => async (clientSid, oidcIdpInfo) => {
  const url = `/hub/clients/${encodeURIComponent(clientSid)}/csv/external-idp-oidc`;

  const axiosConfig = {
    method: 'POST',
    baseURL,
    url,
    data: { oidcIdpInfo }
  };

  const axiosResponse = await axios(axiosConfig);

  if (!axiosResponse || !axiosResponse.data || typeof axiosResponse.data !== 'object') {
    throw new Error('Invalid response from gateway');
  }
  return axiosResponse.data;
};
